import { render, staticRenderFns } from "./tree-drop-down-box-balance.vue?vue&type=template&id=545eccc7&scoped=true&"
import script from "./tree-drop-down-box-balance.vue?vue&type=script&lang=ts&"
export * from "./tree-drop-down-box-balance.vue?vue&type=script&lang=ts&"
import style0 from "./tree-drop-down-box-balance.vue?vue&type=style&index=0&id=545eccc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545eccc7",
  null
  
)

export default component.exports